/* Acrylic Styles — product page behavior
   gallery · quantity · option buttons · Cash on Delivery · frequently bought together ·
   review carousel · recently viewed */
(function () {
  'use strict';

  var AS = function () { return window.AcrylicStyles || {}; };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var v = Number(cents || 0) / 100;
    return 'Rs.' + v.toLocaleString('en-PK', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function toast(msg) {
    var a = AS();
    if (a.toast) a.toast(msg);
  }

  /* ---------- gallery: swipe track + dots + thumbnails ---------- */
  function initGallery(root) {
    var track = root.querySelector('[data-track]');
    if (!track) return;
    var slides = root.querySelectorAll('[data-slide]');
    var dots = root.querySelectorAll('[data-dot]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    var raf = 0;

    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        dots.forEach(function (d, n) { d.classList.toggle('on', n === i); });
        thumbs.forEach(function (t, n) { t.classList.toggle('on', n === i); });
      });
    }, { passive: true });

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-dot],[data-thumb]');
      if (!b) return;
      var i = Number(b.hasAttribute('data-dot') ? b.getAttribute('data-dot') : b.getAttribute('data-thumb'));
      var s = slides[i];
      if (s) track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    });
  }

  /* ---------- quantity stepper ---------- */
  function initQty(root) {
    var input = root.querySelector('input');
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty-btn]');
      if (!b) return;
      input.value = Math.max(1, (Number(input.value) || 1) + Number(b.getAttribute('data-qty-btn')));
    });
  }

  /* ---------- option buttons (Color / Size …) -> variant ---------- */
  function initVariants(form) {
    var dataEl = document.querySelector('[data-variants-json]');
    var groups = form.querySelectorAll('[data-option-group]');
    var idInput = form.querySelector('[data-variant-id-input]');
    var atc = form.querySelector('[data-atc]');
    var cod = form.querySelector('[data-cod]');
    var codText = form.querySelector('[data-cod-text]');
    var page = document.querySelector('.product-page');
    var priceEl = document.querySelector('[data-product-price]');
    var saveEl = document.querySelector('[data-product-save]');
    var card = document.querySelector('.pg-main');
    if (!dataEl || !groups.length || !idInput) return;

    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var currentId = String(idInput.value);

    function chosen() {
      return [].map.call(groups, function (g) {
        var c = g.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function find(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) if (v.options[j] !== opts[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function setBuy(enabled, label) {
      if (atc) { atc.disabled = !enabled; atc.textContent = enabled ? atc.getAttribute('data-label') : label; }
      if (cod) {
        cod.disabled = !enabled;
        if (codText) codText.textContent = enabled ? cod.getAttribute('data-label') : label;
      }
    }

    function update() {
      var opts = chosen();
      var v = find(opts);

      groups.forEach(function (g, gi) {
        var lab = g.querySelector('[data-option-label]');
        if (lab) lab.textContent = opts[gi] || '';
        g.querySelectorAll('.pf-val').forEach(function (wrap) {
          var inp = wrap.querySelector('input');
          var test = opts.slice(); test[gi] = inp.value;
          var m = find(test);
          wrap.classList.toggle('is-off', !m || !m.available);
        });
      });

      if (!v) { setBuy(false, 'Unavailable'); return; }

      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = esc(v.price) + (v.compare ? ' <s>' + esc(v.compare) + '</s>' : '');
      if (saveEl) {
        saveEl.hidden = !(v.save > 0);
        saveEl.textContent = 'Save ' + v.save + '%';
      }
      setBuy(v.available, 'Sold out');

      [page, card].forEach(function (el) { if (el) el.dataset.variantId = v.id; });

      if (String(v.id) !== currentId) {
        currentId = String(v.id);
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (err) {}
        if (v.media > 0) {
          var th = document.querySelector('[data-thumb="' + (v.media - 1) + '"]');
          if (th) th.click();
        }
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-input]')) update();
    });
    update();
  }

  /* ---------- Buy with Cash on Delivery: add to cart, go straight to checkout ---------- */
  function initCod(form) {
    var btn = form.querySelector('[data-cod]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var id = Number(form.querySelector('[data-variant-id-input]').value);
      var qtyEl = form.querySelector('[name="quantity"]');
      var qty = Math.max(1, Number(qtyEl && qtyEl.value) || 1);
      var routes = AS().routes || {};
      if (!id) { toast('Please choose a product option'); return; }
      btn.disabled = true;
      fetch((routes.cartAdd || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = routes.checkout || '/checkout';
      }).catch(function () {
        btn.disabled = false;
        toast('Could not start checkout');
      });
    });
  }

  /* ---------- frequently bought together rows ---------- */
  function initFbt(root) {
    function unitPrice(row) {
      return row.querySelector('[data-fbt-variant]');
    }

    root.addEventListener('change', function (e) {
      var sel = e.target.closest('select[data-fbt-variant]');
      if (!sel) return;
      var row = sel.closest('[data-fbt-row]');
      var opt = sel.options[sel.selectedIndex];
      var priceEl = row.querySelector('[data-fbt-price]');
      var saveEl = row.querySelector('[data-fbt-save]');
      var cmp = opt.getAttribute('data-compare');
      var save = Number(opt.getAttribute('data-save') || 0);
      if (priceEl) priceEl.innerHTML = esc(opt.getAttribute('data-price')) + (cmp ? ' <s>' + esc(cmp) + '</s>' : '');
      if (saveEl) { saveEl.hidden = !(save > 0); saveEl.textContent = 'Save ' + save + '%'; }
    });

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-fbt-pick]');
      if (!btn) return;
      var row = btn.closest('[data-fbt-row]');
      var field = unitPrice(row);
      if (!field) return;

      // products with several variants: first click reveals the chooser
      if (field.tagName === 'SELECT' && field.hidden) {
        field.hidden = false;
        btn.textContent = 'Add to bag';
        field.focus();
        return;
      }
      var a = AS();
      if (a.addMany) a.addMany([{ id: field.value, quantity: 1 }]);
    });
  }

  /* ---------- horizontal carousel (customer reviews) ---------- */
  function initCarousel(root) {
    var track = root.querySelector('[data-car-track]');
    if (!track) return;
    var prev = root.querySelector('.prev');
    var next = root.querySelector('.next');

    function step() {
      var item = track.querySelector('.car-item');
      return item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
    }
    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      root.classList.toggle('no-scroll', max <= 0);
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-car]');
      if (b) track.scrollBy({ left: Number(b.getAttribute('data-car')) * step(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  /* ---------- recently viewed (from the visitor's browser) ---------- */
  function initRecent(block) {
    var rec = document.querySelector('[data-recent-record]');
    var currentId = (rec && rec.dataset.productId) || '';
    var list = [];
    try { list = JSON.parse(localStorage.getItem('as_recent') || '[]'); } catch (err) {}
    list = list.filter(function (x) { return x && String(x.id) !== String(currentId) && x.url; }).slice(0, 8);
    if (!list.length) return;

    block.querySelector('[data-recent-grid]').innerHTML = list.map(function (x) {
      return '<a class="card" href="' + esc(x.url) + '" data-product-card data-product-id="' + esc(x.id) +
        '" data-product-handle="' + esc(x.handle || '') + '" data-variant-id="' + esc(x.variantId || '') +
        '" data-title="' + esc(x.title) + '" data-price="' + esc(x.price || 0) + '" data-image="' + esc(x.image || '') +
        '" data-url="' + esc(x.url) + '"><div class="im"><img src="' + esc(x.image || '') + '" alt="' + esc(x.title) +
        '" loading="lazy"><button type="button" class="fav-btn" data-fav aria-label="Add to favorites">' +
        '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20s-7.5-4.6-9.3-9.2C1.5 7.5 3.4 4.5 6.6 4.5c1.9 0 3.5 1 5.4 3 1.9-2 3.5-3 5.4-3 3.2 0 5.1 3 3.9 6.3C19.5 15.4 12 20 12 20z"/></svg>' +
        '</button></div><h3>' + esc(x.title) + '</h3><div class="pr">' + money(100 * (x.price || 0)) + '</div>' +
        (x.variantId ? '<button type="button" class="add-btn" data-add-to-cart>Add to bag</button>' : '') + '</a>';
    }).join('');
    block.hidden = false;
  }

  function init() {
    document.querySelectorAll('[data-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-qty]').forEach(initQty);
    document.querySelectorAll('form.product-form').forEach(function (f) { initVariants(f); initCod(f); });
    document.querySelectorAll('[data-fbt]').forEach(initFbt);
    document.querySelectorAll('[data-carousel]').forEach(initCarousel);
    document.querySelectorAll('[data-recent-block]').forEach(initRecent);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
